import axiosPortal from "../axios-portal";
import { handleApiError } from "../common/util";
import { ICompanyDetail, IDatabaseDetail } from "../models/portal.model";

export const getCompanyByCompanyUid = async (companyUid: string) => {
  try {
    const url = `/api/company/${companyUid}/v2/details`;
    const response = await axiosPortal.get<ICompanyDetail[]>(url);
    return response.data[0];
  } catch (err: any) {
    return handleApiError(getCompanyByCompanyUid.name, err);
  }
};

export const getCompanyDatabasesByUid = async (uid: string) => {
  try {
    const url = `/api/database/v1/company/${uid}/databases`;
    const response = await axiosPortal.get<IDatabaseDetail[]>(url);
    return response.data;
  } catch (err: any) {
    return handleApiError(getCompanyDatabasesByUid.name, err);
  }
};
